import {
    RECEIVE_ORDER,
    FETCH_ERROR,
    IS_LOADING,
    IS_ITEMS_LOADING,
    RECEIVE_PAYMENTS
} from "../actions/orderDetailActions";
import { OrderDetailState } from '../state/orderDetailState'
import MOrderListItem from '../../models/MOrderListItem'
import OrderPaymentItem from '../../models/OrderPaymentItem'
const initState: OrderDetailState = {
    loading: false,
    itemsLoading: true,
    orderDetail: new MOrderListItem({}),
    orderPayments: [new OrderPaymentItem({})],
    fetchError: false
};

const OrderDetailReducer = (state: OrderDetailState = initState, action) => {
    switch (action.type) {
        case RECEIVE_ORDER: {
            return {
                ...state,
                orderDetail: action.payload,
                fetchError: false,
            }
        }
        case RECEIVE_PAYMENTS: {
            return {
                ...state,
                orderPayments: action.payload,
                fetchError: false,
            }
        }
        case FETCH_ERROR: {
            return {
                ...state,
                fetchError: true,
                loading: false,
                itemsLoading: false
            }
        }
        case IS_LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case IS_ITEMS_LOADING:
            return {
                ...state,
                itemsLoading: action.payload
            }
        default: return state;
    }

}

export default OrderDetailReducer;
